<template>
  <span>
    <button
      class="btn btn-success btn-rounded px-4 rounded-pill"
      v-b-modal="'addTaskModal' + _uid"
    >
      <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
      munkafolyamat
    </button>
    <b-modal
      :id="'addTaskModal' + _uid"
      size="xl"
      cancel-variant="default"
      @cancel="confirmCloseAddModal"
      @ok="addTask"
      cancel-title="Mégse"
      :ok-disabled="loading"
      @shown="$refs.task_name_input.focus()"
      :no-close-on-backdrop="true"
    >
      <template slot="modal-header">
        <h4 class="modal-title">
          Új munkafolyamat<span v-if="wizard_step > 1">- {{ task.name }}</span>
        </h4>
        <a class="btn-close" @click="confirmCloseAddModal()"></a>
      </template>
      <b-container>
        <div class="nav-wizards-container">
          <nav class="nav nav-wizards-1 mb-2">
            <div class="nav-item col" v-for="step in steps" :key="step.id">
              <a
                class="nav-link"
                @click="wizard_step = step.id"
                :class="{
                  active: wizard_step == step.id,
                  completed: wizard_step > step.id,
                  disabled: wizard_step < step.id,
                }"
                href="#"
              >
                <div class="nav-no">{{ step.id }}</div>
                <div class="nav-text">{{ step.name }}</div>
              </a>
            </div>
          </nav>
        </div>
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="wizard_step++" v-show="wizard_step == 1">
              <label class="form-label">Megnevezés:</label>
              <input
                type="text"
                class="form-control"
                v-model="task.name"
                ref="task_name_input"
                required
              />
              <input type="hidden" />
              <button
                ref="modal_form_submit_1"
                hidden
                type="submit"
                class="btn btn-xs btn-success float-end mt-2"
              >
                Következő<i class="fa fa-arrow-right"></i>
              </button>
            </form>
            <form @submit.prevent="wizard_step++" v-show="wizard_step == 2">
              <h5>Munkafolyamat:</h5>
              <div class="form-check mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="crane_checkbox"
                  :true-value="1"
                  :false-value="0"
                  v-model="task.crane"
                />
                <label class="form-check-label" for="crane_checkbox"
                  >Emelőgépet igénylő munkafolyamat</label
                >
              </div>
              <div class="form-group mb-3">
                <div class="row">
                  <div class="col-lg-6">
                    <label class="form-label">Hajtások hozzáadása:</label>
                    <v-select
                      multiple
                      v-if="positions"
                      v-model="task.position_ids"
                      :disabled="![0, 1].includes(position_add_mode)"
                      @option:selected="setPositionAddMode(1)"
                      :options="
                        positions
                          .filter(
                            (p) =>
                              !p.unlisted &&
                              (p.boxes.length == 0 || !p.is_high_voltage)
                          )
                          .map((m) => ({
                            id: m.id,
                            full_name: m.full_name,
                          }))
                      "
                      label="full_name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          placeholder="Válassz Hajtást!"
                        />
                      </template>
                      <template #selected-option-container="{ option }">
                        <span class="d-none">{{ option }}</span>
                      </template>
                    </v-select>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label">Egység hozzáadása:</label>
                    <v-select
                      v-if="units"
                      v-model="unit_to_add"
                      @option:selected="setPositionAddMode(2)"
                      :disabled="![0, 2].includes(position_add_mode)"
                      :options="units"
                      label="name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          :placeholder="
                            unit_to_add == null ? 'Válassz Egységet!' : ''
                          "
                        />
                      </template>
                      <template #selected-option="{}">
                        <span
                          ><i class="fas fa-cog fa-spin"></i> Hozzáadás
                          folyamatban..</span
                        >
                      </template>
                    </v-select>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label"
                      >Csoport lakat szekrény hozzáadása:</label
                    >
                    <v-select
                      v-if="boxes"
                      v-model="box_to_add"
                      @option:selected="setPositionAddMode(3)"
                        :disabled="![0, 3].includes(position_add_mode) || task.position_ids.some(p => p.box_id !== null)"
                      :options="sortedBoxes"
                      label="name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          :placeholder="
                            box_to_add == null
                              ? 'Válassz csoport lakat szekrényt!'
                              : ''
                          "
                        />
                      </template>
                      <template #option="{ name, number }">
                        <p>
                          <b>{{ number }}</b> | {{ name }}
                        </p>
                      </template>
                      <template #selected-option="{}">
                        <span
                          ><i class="fas fa-cog fa-spin"></i> Hozzáadás
                          folyamatban..</span
                        >
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="form-group mb-3">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="(position, id) in task.position_ids" :key="id">
                      <td class="align-middle">
                        <span class="fw-bold">
                          <button
                            @click="deletePositionIdFromTask(id)"
                            type="button"
                            class="btn btn-link text-red"
                          >
                            <i class="fa fa-delete-left fa-2x"></i>
                          </button>
                          {{
                            positions[
                              positions.map((p) => p.id).indexOf(position.id)
                            ].full_name
                          }}
                        </span>
                        <strong
                          class="text-danger"
                          v-if="
                            positions[
                              positions.map((p) => p.id).indexOf(position.id)
                            ].is_high_voltage
                          "
                        >
                          <i
                            class="fa-solid fa-charging-station text-danger"
                          ></i>
                          (6,3)</strong
                        >
                        <span
                          v-if="position.box_id"
                          class="badge bg-default text-black-strict"
                          ><i class="fa-solid fa-link"></i>
                          {{
                            units.map((u) => u.id).indexOf(position.box_id) !=
                            -1
                              ? units[
                                  units
                                    .map((u) => u.id)
                                    .indexOf(position.box_id)
                                ].name
                              : boxes[
                                  boxes
                                    .map((u) => u.id)
                                    .indexOf(position.box_id)
                                ].name
                          }}</span
                        >
                      </td>
                      <td class="align-middle">
                        <div
                          v-if="
                            !positions.find((p) => p.id == position.id)
                              .non_isolated
                          "
                        >
                          <label
                            class="my-auto"
                            :for="'unplug_checkbox_input' + id"
                            :class="{
                              'text-orange':
                                position.unplug == 1 &&
                                !positions[
                                  positions
                                    .map((p) => p.id)
                                    .indexOf(position.id)
                                ].is_high_voltage,
                              'text-danger':
                                position.unplug == 1 &&
                                positions[
                                  positions
                                    .map((p) => p.id)
                                    .indexOf(position.id)
                                ].is_high_voltage,
                              'text-muted': position.unplug == 0,
                            }"
                            ><i class="fa fa-bolt fa-2x"></i
                          ></label>
                          <input
                            class="d-none"
                            type="checkbox"
                            v-model="position.unplug"
                            @click="checkPosition(position, 1)"
                            :true-value="1"
                            :false-value="0"
                            :id="'unplug_checkbox_input' + id"
                            :disabled="
                              positions.find((p) => p.id == position.id)
                                .is_high_voltage == 1 ||
                              positions.find((p) => p.id == position.id)
                                .non_isolated == 1
                            "
                          />
                        </div>
                      </td>
                      <td class="align-middle">
                        <label
                          :for="'locking_checkbox_input' + id"
                          :class="{
                            'text-orange':
                              position.locking == 1 &&
                              !positions[
                                positions.map((p) => p.id).indexOf(position.id)
                              ].is_high_voltage,
                            'text-danger':
                              position.locking == 1 &&
                              positions[
                                positions.map((p) => p.id).indexOf(position.id)
                              ].is_high_voltage,
                            'text-muted': position.locking == 0,
                          }"
                          ><i class="fa fa-lock fa-2x"></i
                        ></label>
                        <input
                          class="d-none"
                          type="checkbox"
                          v-model="position.locking"
                          @click="checkPosition(position, 2)"
                          :true-value="1"
                          :false-value="0"
                          :id="'locking_checkbox_input' + id"
                          :disabled="
                            positions[
                              positions.map((p) => p.id).indexOf(position.id)
                            ].is_high_voltage == 1
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-red" v-if="errors.position_ids">
                  {{ errors.position_ids[0] }}
                </div>
              </div>
              <button
                ref="modal_form_submit_2"
                hidden
                type="submit"
                class="float-right btn btn-xs btn-success mt-2 float-end"
              >
                Következő<i class="fa fa-arrow-right"></i>
              </button>
            </form>
            <form
              @submit.prevent="wizard_step++"
              v-show="wizard_step == 3"
              class="px-auto gap-3"
            >
              <div class="form-group mb-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :true-value="true"
                    :false-value="false"
                    v-model="outside_job"
                    id="outside_job_checkbox_input"
                  />
                  <label
                    for="outside_job_checkbox_input"
                    class="form-check-label fw-bold fs-6"
                    >Külsős munka</label
                  >
                </div>
                <div class="form-group mb-3" v-if="outside_job">
                  <label class="form-label">Vállalkozó cég:</label>
                  <v-select
                    v-if="partners"
                    v-model="task.partner_id"
                    :options="partners"
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!task.partner_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!task.partner_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                </div>
                <div
                  class="form-group mb-3"
                  v-if="outside_job && task.partner_id"
                >
                  <label class="form-label">Vállalkozó cég vezetője:</label>
                  <v-select
                    v-if="partner_leads"
                    v-model="task.partner_user_id"
                    :options="partner_leads"
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!task.partner_user_id"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!task.partner_user_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                  <Loading
                    title="vállalkozó cég munkavállalóinak betöltése"
                    v-else
                  ></Loading>
                </div>
                <div
                  class="form-group mb-3"
                  v-if="outside_job && task.partner_id"
                >
                  <label class="form-label">Fekete lakat felvevő:</label>
                  <v-select
                    v-if="partner_workers"
                    v-model="task.black_lock_user_id"
                    :options="partner_workers"
                    :reduce="(option) => option.id"
                    label="name"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="
                          !task.black_lock_user_id &&
                          task.position_ids.filter((p) => p.locking == 1)
                            .length > 0
                        "
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!task.black_lock_user_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                  <Loading
                    title="vállalkozó cég munkavállalóinak betöltése"
                    v-else
                  ></Loading>
                </div>

                <div class="form-group mb-3" v-if="outside_job">
                  <CoordinationForm
                    :partners="partners"
                    :users="users"
                    @change="setCoordination"
                  ></CoordinationForm>
                </div>
              </div>
              <!-- Külsős munka felülre mozgatva ha szükséges valamikor alulra valamikor felülr rakni akkor szétszedem komponensekre -->
              <div class="form-group">
                <h5 class="mb-3">Munkavégzők:</h5>
              </div>
              <div class="form-group mb-3">
                <label class="form-label">Kék lakat felvevő:</label>
                <v-select
                  v-if="workers"
                  v-model="task.ddc_user_id"
                  :options="workers"
                  :reduce="(option) => option.id"
                  label="name"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="
                        !task.ddc_user_id && task.position_ids.length != 0
                      "
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="!task.ddc_user_id ? 'Válassz' : ''"
                    />
                  </template>
                </v-select>
              </div>
              <div class="form-group my-3">
                <label class="form-label">Munkaterület:</label>
                <v-select
                  v-if="locations"
                  v-model="task.location_id"
                  :options="locations.filter((l) => l.parent_id == null)"
                  :reduce="(option) => option.id"
                  label="name"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!task.location_id"
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="!task.location_id ? 'Válassz' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger" v-if="showCraneWarning"
                  >A választott munkaterület nem rendelkezik emelődaruval!</span
                >
              </div>
              <div class="form-group my-3">
                <label class="form-label"
                  >A munkaterület következő dátumtól szükséges:</label
                >
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group mt-2">
                      <input
                        type="date"
                        class="form-control"
                        v-model="task.start_date"
                        :min="now"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mt-2">
                      <input
                        v-if="task.with_time"
                        type="time"
                        class="form-control"
                        v-model="task.start_time"
                        required
                      />
                    </div>
                  </div>
                </div>
                <label class="form-label"
                  >A munkaterület a következő dátumig szükséges:</label
                >
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group mt-2">
                      <input
                        type="date"
                        class="form-control"
                        v-model="task.end_date"
                        :min="now"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mt-2">
                      <input
                        v-if="task.with_time"
                        type="time"
                        class="form-control"
                        v-model="task.end_time"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="form-check mt-2">
                  <input
                    class="form-check-input"
                    :true-value="false"
                    :false-value="true"
                    type="checkbox"
                    v-model="task.with_time"
                    id="with_time_input"
                  />
                  <label class="form-check-label" for="with_time_input"
                    >Egész nap</label
                  >
                </div>
              </div>
              <div class="form-group my-3">
                <label class="form-label">Területvezető:</label>
                <v-select
                  v-if="location_leads"
                  v-model="task.location_leader_id"
                  :options="location_leads"
                  :reduce="(option) => option.id"
                  label="name"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!task.location_leader_id"
                      v-bind="attributes"
                      v-on="events"
                      :placeholder="!task.location_leader_id ? 'Válassz' : ''"
                    />
                  </template>
                </v-select>
              </div>
              <button
                ref="modal_form_submit_3"
                hidden
                type="submit"
                class="float-right btn btn-xs btn-success mt-2 float-end"
              >
                Következő<i class="fa fa-arrow-right"></i>
              </button>
            </form>
            <form @submit.prevent="wizard_step++" v-show="wizard_step == 4">
              <h5>
                Engedélyek:
                <span class="badge bg-info my-2" v-if="outside_job"
                  ><i class="fa fa-info-circle"></i> külsős munka esetén a
                  munkaterület átadási átvételi engedély automatikusan
                  létrejön!</span
                >
              </h5>
              <form @submit.prevent="addToPermits" class="mb-2">
                <div class="row">
                  <div class="col-md-5">
                    <v-select
                      v-if="permit_types"
                      v-model="permit_to_add.permit_type"
                      :options="filtered_permit_types"
                      :reduce="(option) => option.id"
                      label="short_name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          :placeholder="
                            !permit_to_add.permit_type
                              ? 'Válassz engedélyt'
                              : ''
                          "
                          :required="!permit_to_add.permit_type"
                        />
                      </template>
                    </v-select>
                  </div>
                  <div class="col-md-3">
                    <v-select
                      v-if="users"
                      v-model="permit_to_add.user_id"
                      :options="users_available_for_permit"
                      :reduce="(option) => option.id"
                      label="name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          :placeholder="
                            !permit_to_add.user_id ? 'Válassz felhasználót' : ''
                          "
                          :required="!permit_to_add.user_id"
                        />
                      </template>
                    </v-select>
                  </div>
                  <div class="col-md-3">
                    <v-select
                      v-if="permit_local_roles"
                      v-model="permit_to_add.local_role"
                      :options="roles_available_for_permit"
                      :reduce="(option) => option.id"
                      label="name"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          :placeholder="
                            !permit_to_add.local_role ? 'Válassz szerepet' : ''
                          "
                          :required="!permit_to_add.local_role"
                        />
                      </template>
                    </v-select>
                  </div>
                  <div class="col-1">
                    <button type="submit" class="btn btn-success">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </form>
              <table
                class="table table-hover"
                v-if="
                  task.permits.length > 0 && typeof task.permits != 'string'
                "
              >
                <tbody>
                  <tr v-for="(permit, id) in task.permits" :key="id">
                    <td class="align-middle">
                      <button
                        type="button"
                        @click="removePermit(id)"
                        class="btn btn-link text-red"
                      >
                        <i class="fa fa-delete-left fa-2x"></i>
                      </button>
                    </td>
                    <td class="align-middle fw-bold">
                      {{
                        users[users.map((u) => u.id).indexOf(permit.user_id)]
                          .name
                      }}
                    </td>
                    <td class="align-middle">
                      {{
                        permit_types[
                          permit_types
                            .map((p) => p.id)
                            .indexOf(permit.permit_type)
                        ].name
                      }}
                    </td>
                    <td class="align-middle">
                      {{
                        permit_local_roles[
                          permit_local_roles
                            .map((p) => p.id)
                            .indexOf(permit.local_role)
                        ].name
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                ref="modal_form_submit_4"
                hidden
                type="submit"
                class="float-right btn btn-xs btn-success mt-2 float-end"
              >
                Következő<i class="fa fa-arrow-right"></i>
              </button>
            </form>
            <form @submit.prevent="wizard_step = 5" v-show="wizard_step == 5">
              <div v-if="!loading">
                <div class="form-group">
                  <label class="form-label"
                    >Engedélyeken szereplő kiegészítő információk:</label
                  >
                  <textarea
                    class="form-control"
                    v-model="task.description"
                    cols="30"
                    rows="5"
                  ></textarea>
                </div>
                <div class="form-group mt-3">
                  <label class="form-label">Megjegyzés:</label>
                  <textarea
                    class="form-control"
                    v-model="task.initial_comment"
                    cols="20"
                    rows="3"
                  ></textarea>
                </div>
                <div class="form-group mt-3">
                  <label class="form-label">Utasítás:</label>
                  <v-select
                    v-if="partners"
                    v-model="task.workflow_id"
                    :options="workflows"
                    :reduce="(option) => option.id"
                    label="name"
                    :disabled="unique_workflow"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        :placeholder="!task.workflow_id ? 'Válassz' : ''"
                      />
                    </template>
                  </v-select>
                </div>
                <div class="form-group mt-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="unique_workflow"
                      id="unique_workflow_checkbox_input"
                    />
                    <label
                      for="unique_workflow_checkbox_input"
                      class="form-check-label"
                      >Egyedi munkafolyamat</label
                    >
                  </div>
                </div>
                <div class="form-group mt-3" v-if="unique_workflow">
                  <label class="form-label">Megnevezés:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="workflow.name"
                    :class="{ 'is-invalid': errors.name }"
                    required
                  />
                  <div v-if="errors.name" class="invalid-feedback d-block">
                    {{ errors.name[0] }}
                  </div>
                </div>
                <div class="form-group mt-3" v-if="unique_workflow">
                  <label class="form-label">Leírás:</label>
                  <textarea
                    class="form-control"
                    cols="30"
                    rows="10"
                    v-model="workflow.description"
                    :class="{ 'is-invalid': errors.description }"
                    required
                  ></textarea>
                  <div
                    v-if="errors.description"
                    class="invalid-feedback d-block"
                  >
                    {{ errors.description[0] }}
                  </div>
                </div>
                <button
                  ref="modal_form_submit_5"
                  hidden
                  type="submit"
                  class="float-right btn btn-xs btn-success mt-2 float-end"
                >
                  Következő<i class="fa fa-arrow-right"></i>
                </button>
              </div>
              <Loading v-else title="Létrehozás"></Loading>
            </form>
          </div>
        </div>
      </b-container>
      <template #modal-footer="{ ok, cancel }">
        <div class="w-100 h-auto">
          <div class="row">
            <div class="col-4">
              <p class="float-start m-0">
                <b-button
                  size="md"
                  variant="danger"
                  @click="cancel()"
                  class="float-left"
                >
                  Mégse
                </b-button>
                <b-button
                  size="md"
                  variant="warning"
                  @click="saveAsDraft()"
                  class="float-left mx-2"
                >
                  Vázlat mentése
                </b-button>
              </p>
            </div>
            <div class="col-4 text-center align-self-center">
              <risks-icon :comment-line-break="true"></risks-icon>
            </div>
            <div class="col-4">
              <b-button
                size="md"
                variant="success"
                @click="ok()"
                class="float-end mx-2"
                :disabled="initializing"
              >
                {{ wizard_step == 5 ? "Létrehozás" : "Következő" }}
              </b-button>
              <b-button
                size="md"
                v-if="wizard_step != 1"
                variant="outline-secondary"
                @click="wizard_step--"
                class="float-end mx-2"
              >
                Előző
              </b-button>
              <b-modal
                :id="'send-task-modal' + _uid"
                cancel-title="Mégsem"
                ok-title="Létrehozom"
                @ok="sendTask"
                @cancel="task.end_comment = ''"
              >
                <template slot="modal-header">
                  <h4 class="modal-title">Munkafolyamat létrehozás</h4>
                  <a
                    class="btn-close"
                    @click="$bvModal.hide('send-task-modal' + _uid)"
                  ></a>
                </template>
                <b-container class="text-center">
                  <i
                    class="fa-solid fa-circle-exclamation text-warning fa-4x fa-beat-fade mb-3"
                    style="--fa-animation-duration: 3s"
                  ></i>
                  <h3>
                    A területvezető részéről kérem tudomásul venni a
                    munkavégzést.
                  </h3>
                  <h5>
                    Emellett kérem megfogalmazni az adott munkaterületen
                    esetlegesen végzett egyéb tevékenységeket, amelyek érintik a
                    jelen munkavégzést.
                  </h5>
                  <p>
                    Az alábbi kérdések merültek fel bennem a munkavégzés
                    engedélyezésével kapcsolatban:
                  </p>
                  <textarea
                    class="form-control"
                    v-model="task.end_comment"
                  ></textarea>
                </b-container>
              </b-modal>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import moment from "moment";
import Loading from "../../components/Loading";
import Task from "../../apis/Task";
import Confirmation from "../../apis/Confirmation";
import Workflow from "../../apis/Workflow";
import User from "../../apis/User";
import Partner from "../../apis/Partner";
import Box from "../../apis/Box";
import Location from "../../apis/Location";
import Draft from "../../apis/Draft";
import RisksIcon from "../../components/RisksIcon";
import CoordinationForm from "../CoordinationForm.vue";
import TaskModel from "../../models/TaskModel";

export default {
  components: {
    Loading,
    RisksIcon,
    CoordinationForm,
  },
  data() {
    return {
      task: new TaskModel(),
      loading: false,
      wizard_step: 1,
      errors: [],
      steps: [
        { id: 1, name: "Megnevezés" },
        { id: 2, name: "Lakatolás kell?" },
        { id: 3, name: "Munkavégzők" },
        { id: 4, name: "Engedélyek" },
        { id: 5, name: "Kiegészítő információk" },
      ],
      position_add_mode: 0,
      copying: false,
      originalPositionIds: [],
      units: false,
      boxes: false,
      locations: false,
      now: moment().format("YYYY-MM-DD"),
      unique_workflow: false,
      partners: false,
      outside_job: false,
      users: false,
      permit_types: false,
      permit_local_roles: false,
      permit_to_add: {},
      box_to_add: null,
      unit_to_add: null,
      partner_leads: false,
      partner_workers: false,
      workflows: false,
      workflow: {},
      showCraneWarning: false,
      addedUnits: [],
    };
  },
  computed: {
    locationslinear() {
      return this.$store.state.locationslinear;
    },
    positions() {
      let temporary = this.$store.state.positions;
      temporary.forEach((p) => {
        let location = this.locationslinear.find((l) => l.id == p.location_id);
        location = location ? location.name : "Nincs megadva";
        this.$set(
          p,
          "full_name",
          p.position_id + " - " + p.name + " (" + location + ")"
        );
      });
      return temporary;
    },
    draft_object() {
      return {
        task: this.task,
        position_add_mode: this.position_add_mode,
        unique_workflow: this.unique_workflow,
        outside_job: this.outside_job,
        workflow: this.workflow,
      };
    },
    initializing() {
      if (
        this.users === false ||
        this.partners === false ||
        this.boxes === false ||
        this.positions === false ||
        this.permit_types === false ||
        this.security_types === false ||
        this.workflows === false ||
        this.units === false ||
        this.permit_local_roles === false ||
        this.locations === false ||
        this.locationslinear === false
      ) {
        return true;
      } else {
        return false;
      }
    },
    workers() {
      if (this.users) {
        if (this.hasRadiatingUnits) {
          return this.users
            .filter((u) => u.roles.includes(10))
            .filter(
              (u) => u.has_valid_radiation_protection_certificate == true
            );
        } else {
          return this.users.filter((u) => u.roles.includes(10));
        }
      } else {
        return [];
      }
    },
    location_leads() {
      if (this.users) {
        return this.users.filter((u) => u.roles.includes(3));
      } else {
        return [];
      }
    },
    users_available_for_permit() {
      if (typeof this.permit_to_add.permit_type == "undefined") {
        return [];
      }
      let users = this.users;
      if (this.permit_to_add.permit_type == 1) {
        users = users.filter((u) => u.has_valid_fire_certificate == true);
      }
      if (this.permit_to_add.permit_type == 3) {
        users = users
          .filter((u) => u.partner_id == this.task.partner_id)
          .filter((u) => u.roles.includes(6));
      }
      if (this.hasRadiatingUnits) {
        users = users.filter(
          (u) => u.has_valid_radiation_protection_certificate == true
        );
      }

      return users;
    },
    roles_available_for_permit() {
      if (typeof this.permit_to_add.permit_type == "undefined") {
        return [];
      }
      let roles = this.permit_local_roles;
      if (this.permit_to_add.permit_type == 4) {
        roles = roles.filter((u) => u.id != 2);
      }
      if (this.permit_to_add.permit_type == 1) {
        roles = roles.filter((u) => u.id == 1);
      }
      if (this.permit_to_add.permit_type == 3) {
        roles = roles.filter((u) => u.id == 3);
      }

      return roles;
    },
    sortedBoxes() {
      return this.boxes
        .filter((b) => b.id != null)
        .sort((a, b) => a.location_id - b.location_id);
    },
    filtered_permit_types() {
      if (this.outside_job) {
        return this.permit_types.filter((p) => p.id != 5);
      } else {
        return this.permit_types.filter((p) => ![3, 5].includes(p.id));
      }
    },
    hasRadiatingUnits() {
      if (this.addedUnits.length > 0) {
        return this.units
          .filter((u) => this.addedUnits.includes(u.id))
          .some((u) => u.is_radiating == 1);
      }
      return false;
    },
  },
  watch: {
    initializing: function (val, oldVal) {
      if (val == false && oldVal == true) {
        if (this.btnToClick) {
          setTimeout(() => {
            this.$refs[this.btnToClick].focus();
            this.$refs[this.btnToClick].click();
            setTimeout(() => {
              this.$store.commit("updateBtnToClick", false);
            }, 2000);
          }, 500);
        }
      }
    },
    wizard_step: function (val) {
      if (val == 4 && this.outside_job) {
        /*this.task.permits.push("4");
                document.getElementById('perimt_checkbox_input3').checked = true;*/
      }
    },
    outside_job: function (value) {
      if (!value && !this.task.id) {
        this.$set(this.task, "partner_id", undefined);
        this.$set(this.task, "permits", []);
        this.$delete(this.task, "partner_user_id");
        this.$delete(this.task, "black_lock_user_id");
        /*document.getElementsByClassName("permit_checkbox").forEach(pcb => {
                    pcb.checked = false;
                });*/
      }
    },
    "task.security_type": function (val, oldVal) {
      if (val != oldVal && !this.task.id) {
        //this.$set(this.task, 'position_ids', []);
        this.$delete(this.task, "box_id");
      }
    },
    "task.partner_id": function (val) {
      if (val) {
        if (!this.copying) {
          this.$delete(this.task, "partner_user_id");
          this.$delete(this.task, "black_lock_user_id");
        }
        this.partner_leads = false;
        this.partner_workers = false;

        User.getRoles([6]).then((response) => {
          if (response.data.length != 0) {
            this.partner_leads = response.data.filter(
              (item) => item.partner_id == val
            );
            this.partner_leads.forEach((pw) => {
              this.$set(
                pw,
                "name",
                pw.last_name +
                  " " +
                  pw.first_name +
                  (pw.name_extension != null ? " " + pw.name_extension : "") +
                  (pw.partner_id != null ? " (" + pw.partner_name + ")" : "")
              );
            });
          } else {
            this.partner_leads = response.data;
          }
        });

        User.getRoles([11]).then((response) => {
          if (response.data.length != 0) {
            this.partner_workers = response.data.filter(
              (item) => item.partner_id == val
            );
            this.partner_workers.forEach((pw) => {
              this.$set(
                pw,
                "name",
                pw.last_name +
                  " " +
                  pw.first_name +
                  (pw.name_extension != null ? " " + pw.name_extension : "") +
                  (pw.partner_id != null ? " (" + pw.partner_name + ")" : "")
              );
            });
          } else {
            this.partner_workers = response.data;
          }
        });
      }
    },
    /*'task.partner_user_id': function (val) {
            if (!this.task.black_lock_user_id) {
                this.$set(this.task, 'black_lock_user_id', val);
            }
        },*/

    "task.position_ids": function (val, oldVal) {
      if (val && !this.task.id) {
        //az elsőként hozzáadott hajtás alapján beállítsa a területet és a TV_t
        if (
          (oldVal.length == 0 || oldVal.length == val.length) &&
          val.length != 0
        ) {
          new Promise((resolve) => {
            let location =
              this.locationslinear[
                this.locationslinear
                  .map((l) => l.id)
                  .indexOf(
                    this.positions[
                      this.positions.map((p) => p.id).indexOf(val[0].id)
                    ].location_id
                  )
              ];
            let location_id = null;
            if (location.parent_id) {
              location_id = location.parent_id;
            } else {
              location_id = location.id;
            }
            resolve(location_id);
          }).then((location_id) => {
            if (location_id != this.task.location_id) {
              this.$set(this.task, "location_id", location_id);
              this.$set(
                this.task,
                "location_leader_id",
                this.locations[
                  this.locations.map((l) => l.id).indexOf(location_id)
                ].leader_id
              );
            }
          });
        }
        //végigmegyünk mindegyiken és beállítjuk a villámokat és lakatokat

        val.forEach((position) => {
          if (
            oldVal == null ||
            oldVal.length == 0 ||
            !oldVal.map((p) => p.id).includes(position.id)
          ) {
            this.$set(position, "locking", 1);
            //akkor kell az unplug értékét 0-ra állítani, ha a non_isolated értéke 1 vagy a position_id benne van az eredeti position_ids-ben és ott az unplug értéke 0
            if (
              this.originalPositionIds &&
              this.originalPositionIds.find(
                (p) => p.id == position.id && p.unplug == 0
              )
            ) {
              this.$set(position, "unplug", 0);
            } else if (
              this.positions.find((p) => p.id == position.id).non_isolated == 1
            ) {
              this.$set(position, "unplug", 0);
            } else {
              this.$set(position, "unplug", 1);
            }
          }
        });
      }
      if (val.length == 0) {
        this.setPositionAddMode(0);
      }
    },
    unique_workflow: function () {
      this.task.workflow_id = null;
    },
    unit_to_add: function () {
      this.addUnitToTask();
    },
    box_to_add: function () {
      this.addBoxToTask();
    },
    "task.location_id": function (val, oldVal) {
      if (val && val != oldVal) {
        let chosenLocation =
          this.locations[this.locations.map((l) => l.id).indexOf(val)];
        let lid = chosenLocation.leader_id;
        if (lid != null) {
          this.task.location_leader_id = lid;
        }

        this.showCraneWarning =
          this.task.crane == true && chosenLocation.has_cranes == false;
      }
    },
    "task.crane": function () {
      let chosenLocation =
        this.locations[
          this.locations.map((l) => l.id).indexOf(this.task.location_id)
        ];
      if (chosenLocation) {
        this.showCraneWarning =
          this.task.crane == true && chosenLocation.has_cranes == false;
      }
    },
    "permit_to_add.permit_type": function (val) {
      if (val == 1) {
        this.$set(this.permit_to_add, "local_role", 1);
      } else if (val == 3) {
        this.$set(this.permit_to_add, "local_role", 3);
      } else {
        this.$set(this.permit_to_add, "local_role", null);
      }
    },
  },
  created() {
    Location.index().then((response) => {
      this.locations = response.data;
    });
    Workflow.index().then((response) => {
      this.workflows = response.data;
    });
    User.index().then((response) => {
      this.users = response.data;
      this.users.forEach((u) => {
        this.$set(
          u,
          "name",
          u.last_name +
            " " +
            u.first_name +
            (u.name_extension != null ? " " + u.name_extension : "") +
            (u.partner_id != null ? " (" + u.partner_name + ")" : "")
        );
      });
    });
    Partner.index().then((response) => {
      this.partners = response.data;
    });
    Box.index().then((response) => {
      this.boxes = response.data;
    });
    Box.units().then((response) => {
      this.units = response.data;
    });

    this.permit_types = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types;
    this.security_types = JSON.parse(
      localStorage.getItem("constants")
    ).security_types;
    this.permit_local_roles = JSON.parse(
      localStorage.getItem("constants")
    ).permit_local_roles;
  },
  mounted() {
    this.$root.$on("task-load", this.loadTaskData);
  },
  methods: {
    loadTaskData(data) {
      data.task.permits = data.task.permits.filter(function (permit) {
        return permit.permit_type !== 5;
      });
      this.copying = true;

      this.task = data.task;
      this.originalPositionIds = data.task.position_ids;

      //TODO megnézni, hogy ez működik-e enélkül
      //this.$set(this.task,'position_ids',data.task.position_ids);

      this.position_add_mode = data.position_add_mode;
      this.unique_workflow = data.unique_workflow;
      this.outside_job = data.outside_job;
      this.workflow = data.workflow;
      this.$bvModal.show("addTaskModal" + this._uid);
    },
    isUnfinishedPermit() {
      let exists = false;
      this.task.permits.forEach((permit) => {
        if ([2, 3, 4].includes(permit.permit_type)) {
          if (
            this.task.permits
              .filter((p) => p.permit_type == permit.permit_type)
              .filter((fp) => fp.local_role == 3).length == 0
          ) {
            exists = true;
          }
        }
      });
      return exists;
    },
    isNarrowUnfinished() {
      if (this.task.permits.filter((p) => p.permit_type == 2).length == 0) {
        return false;
      } else {
        let exists = false;
        this.task.permits
          .filter((p) => p.permit_type == 2)
          .forEach((permit) => {
            let leads = this.task.permits
              .filter((p) => p.permit_type == permit.permit_type)
              .filter((fp) => fp.local_role == 3);
            let watchers = this.task.permits
              .filter((p) => p.permit_type == permit.permit_type)
              .filter((fp) => fp.local_role == 2);
            if (leads.length == 0 || watchers.length == 0) {
              exists = true;
            }
          });
        return exists;
      }
    },
    isNarrowPartnerUnfinished() {
      if (this.task.permits.filter((p) => p.permit_type == 3).length == 0) {
        return false;
      } else {
        let exists = false;
        this.task.permits
          .filter((p) => p.permit_type == 3)
          .forEach((permit) => {
            let leads = this.task.permits
              .filter((p) => p.permit_type == permit.permit_type)
              .filter((fp) => fp.local_role == 3);

            if (leads.length == 0) {
              exists = true;
            }
          });
        return exists;
      }
    },
    isHighMissingRoles() {
      //legyen egy 3mas local_role és legalább egy másik is
      if (this.task.permits.filter((p) => p.permit_type == 4).length == 0) {
        return false;
      }
      let missing = true;
      this.task.permits
        .filter((p) => p.permit_type == 4)
        .forEach((permit) => {
          let leads = this.task.permits
            .filter((p) => p.permit_type == permit.permit_type)
            .filter((fp) => fp.local_role == 3);
          let watchers = this.task.permits
            .filter((p) => p.permit_type == permit.permit_type)
            .filter((fp) => fp.local_role != 3);

          if (leads.length > 0 && watchers.length > 0) {
            missing = false;
          }
        });
      return missing;
    },
    isHighUnfinished() {
      let insiders = this.task.permits.filter(
        (p) =>
          p.permit_type == 4 &&
          !this.users.find((u) => u.id == p.user_id).partner_id
      );
      let outsiders = this.task.permits.filter(
        (p) =>
          p.permit_type == 4 &&
          this.users.find((u) => u.id == p.user_id).partner_id
      );
      if (
        insiders.length > 0 &&
        insiders.filter((i) => i.local_role == 3).length == 0
      ) {
        return true;
      } else if (
        outsiders.length > 0 &&
        outsiders.filter((o) => o.local_role == 3).length == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    removePermit(id) {
      this.task.permits.splice(id, 1);
    },
    addToPermits() {
      let errormsg = false;
      switch (this.permit_to_add.permit_type) {
        case 1:
          if (
            !this.users[
              this.users.map((u) => u.id).indexOf(this.permit_to_add.user_id)
            ].has_valid_fire_certificate
          ) {
            errormsg =
              "Csak érvényes tűzgyújtásival adható ki tűzgyújtási engedély!";
          }
          break;
        case 3:
          if (
            !this.users[
              this.users.map((u) => u.id).indexOf(this.permit_to_add.user_id)
            ].partner_id
          ) {
            errormsg = "Csak külsős munkavállalónak adható ki külsős engedély!";
          }
          break;
      }
      if (!errormsg) {
        this.task.permits.push(this.permit_to_add);
        this.permit_to_add = {};
      } else {
        Confirmation.swalErrorMessage(errormsg);
      }
    },
    addBoxToTask() {
      setTimeout(() => {
        if (this.box_to_add != null) {
          //this.task.position_ids = [];
          //this.task.box_id = this.box_to_add.id;
          this.box_to_add.locks.forEach((lock) => {
            if (
              this.task.position_ids.filter(
                (p) => p.id == lock.pivot.position_id
              ).length == 0
            ) {
              let newpos = JSON.parse(
                JSON.stringify(
                  this.positions[
                    this.positions
                      .map((po) => po.id)
                      .indexOf(lock.pivot.position_id)
                  ]
                )
              );
              newpos = {
                id: newpos.id,
                full_name: newpos.full_name,
                box_id: this.box_to_add.id,
              };
              this.$set(newpos, "locking", 1);
              if (
                this.positions.find((p) => p.id == newpos.id).non_isolated == 1
              ) {
                this.$set(newpos, "unplug", 0);
              } else {
                this.$set(newpos, "unplug", 1);
              }
              this.task.position_ids.push(newpos);
            }
          });
          this.box_to_add = null;
        }
      }, 500);
    },
    addUnitToTask() {
      setTimeout(() => {
        if (this.unit_to_add != null) {
          this.unit_to_add.locks.forEach((lock) => {
            if (
              this.task.position_ids.filter(
                (p) => p.id == lock.pivot.position_id
              ).length == 0
            ) {
              let newpos = JSON.parse(
                JSON.stringify(
                  this.positions[
                    this.positions
                      .map((po) => po.id)
                      .indexOf(lock.pivot.position_id)
                  ]
                )
              );
              newpos = {
                id: newpos.id,
                full_name: newpos.full_name,
                box_id: this.unit_to_add.id,
              };
              this.$set(newpos, "locking", 1);
              if (
                this.positions.find((p) => p.id == newpos.id).non_isolated == 1
              ) {
                this.$set(newpos, "unplug", 0);
              } else {
                this.$set(newpos, "unplug", 1);
              }
              this.task.position_ids.push(newpos);
            }
          });
          this.addedUnits.push(this.unit_to_add.id);
          this.unit_to_add = null;
        }
      }, 500);
    },
    deletePositionIdFromTask(id) {
      if (
        this.positions.find((p) => p.id == this.task.position_ids[id].id)
          .is_high_voltage
      ) {
        if (
          this.task.position_ids.filter(
            (tp) => this.positions.find((p) => p.id == tp.id).is_high_voltage
          ).length == 1 &&
          this.task.position_ids.length > 1
        ) {
          Confirmation.swalErrorMessage(
            "minimum 1 6,3 kw hajtás kell ha szekrényt ad hozzá!"
          );
        } else {
          this.task.position_ids.splice(id, 1);
        }
      } else {
        this.task.position_ids.splice(id, 1);
      }
    },
    checkPosition(position, btn_number) {
      if (btn_number == 1 && position.unplug == 0) {
        this.$set(position, "locking", 1);
      } else if (btn_number == 2 && position.locking == 1) {
        this.$set(position, "unplug", 0);
      }
    },
    setPositionAddMode(mode) {
      this.$set(this, "position_add_mode", mode);
    },
    closeAddModal() {
      this.task = new TaskModel();
      this.wizard_step = 1;
      this.outside_job = false;
      this.workflow = {};
      this.unique_workflow = false;
      this.errors = [];
      this.copying = false;
      this.originalPositionIds = [];
      this.$bvModal.hide("addTaskModal" + this._uid);
    },
    confirmCloseAddModal(bvModalEvt) {
      if (this.task.name) {
        if (bvModalEvt) {
          bvModalEvt.preventDefault();
        }
        Confirmation.swalCloseOrSaveDraft().then((response) => {
          if (response.isConfirmed === true) {
            this.closeAddModal();
          }
        });
      } else {
        this.closeAddModal();
      }
    },
    addTask(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.wizard_step == 5) {
        if (this.unique_workflow) {
          this.loading = true;
          Workflow.add(this.workflow)
            .then((response) => {
              this.workflows.unshift(response.data);
              this.errors = [];
              this.task.workflow_id = response.data.id;
              this.openSendModal();
            })
            .catch((error) => {
              if (error.response.data.errors) {
                this.errors = error.response.data.errors;
              }
              this.loading = false;
            });
        } else {
          this.openSendModal();
        }
      } else if (this.wizard_step == 4) {
        if (this.isUnfinishedPermit()) {
          Confirmation.swalErrorMessage(
            "Ehhez az engedélyhez mindig kell irányító személy!"
          );
        } else if (this.isHighMissingRoles()) {
          Confirmation.swalErrorMessage(
            "Magasban végzett engedélyhez az irányító mellé kell még egy személy!"
          );
        } else if (this.isHighUnfinished()) {
          Confirmation.swalErrorMessage(
            "Ha magasban végzett engedélyt ad ki külön kell választani irányítót belső és külső felhasználók közül is!"
          );
        } else if (this.isNarrowUnfinished()) {
          Confirmation.swalErrorMessage(
            "Belső beszállási engedélyhez mindig kell irányító és figyelő személy!"
          );
        } else if (this.isNarrowPartnerUnfinished()) {
          Confirmation.swalErrorMessage(
            "Külső beszállási engedélyhez mindig kell figyelő személy!"
          );
        } else if (
          [...new Set(Object.values(this.permit_to_add))].length > 1 ||
          ([...new Set(Object.values(this.permit_to_add))].length == 1 &&
            [...new Set(Object.values(this.permit_to_add))][0] != null)
        ) {
          Confirmation.swalContinue().then((response) => {
            if (response.isConfirmed === true) {
              this.permit_to_add = {};
              this.$refs["modal_form_submit_" + this.wizard_step].click();
            }
          });
        } else if (
          this.task.position_ids.length == 0 &&
          this.task.permits.length == 0 &&
          this.task.crane == 0 &&
          !(this.outside_job == true)
        ) {
          Confirmation.swalContinueMessage(
            "Nem választottál hajtásokat, se engedélyeket! Így üres munkafolyamatot hozol létre!"
          ).then((response) => {
            if (response.isConfirmed === true) {
              this.$refs["modal_form_submit_" + this.wizard_step].click();
            }
          });
        } else {
          this.$refs["modal_form_submit_" + this.wizard_step].click();
        }
      } else if (this.wizard_step == 2) {
        let notMarkedForUnplug = this.task.position_ids.filter(
          (t) => t.unplug == 0
        ).length;
        let nonIsolatedPositions = this.positions
          .filter((position) =>
            this.task.position_ids.map((a) => a.id).includes(position.id)
          )
          .filter((position) => position.non_isolated == 1).length;

        if (this.task.position_ids.length == 0 && this.task.crane == 0) {
          Confirmation.swalContinueMessage(
            "Nem választottál hajtásokat és emelődaruzást sem, így a feladat nem igényel lakatolást"
          ).then((response) => {
            if (response.isConfirmed === true) {
              this.$refs["modal_form_submit_" + this.wizard_step].click();
            }
          });
        } else if (
          notMarkedForUnplug != 0 &&
          notMarkedForUnplug != nonIsolatedPositions
        ) {
          Confirmation.swalContinueMessage(
            "Kijelentem, hogy a berendezés indítása során meggyőződöm az indítás alapfeltételeiről és a berendezés működtetésének idejére biztosítom a berendezés(ek) területén történő munkafolyamatok biztonságosságát, valamint az általam esetlegesen megbízott személyt a fentiekkel kapcsolatban teljeskörűen tájékoztatom."
          ).then((response) => {
            if (response.isConfirmed === true) {
              this.$refs["modal_form_submit_" + this.wizard_step].click();
            }
          });
        } else {
          this.$refs["modal_form_submit_" + this.wizard_step].click();
        }
      } else {
        this.$refs["modal_form_submit_" + this.wizard_step].click();
      }
    },
    sendTask() {
      this.loading = true;
      //this.task.permits = JSON.stringify(this.task.permits); //atalakitani a backendet addig maradjon vagy összefossa magát
      Task.add(this.task)
        .then((response) => {
          this.sendEnd(response.data);
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
            if (this.errors.position_ids) {
              this.wizard_step = 2;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendEnd(task) {
      this.$emit("task-created", task);
      this.errors = [];
      this.closeAddModal();
      this.$router.push({ path: "/tasks/" + task.id + "/edit" });
    },
    openSendModal() {
      if (
        this.task.position_ids.length == 0 &&
        this.task.permits.length == 0 &&
        !this.task.partner_id &&
        this.task.crane == 0
      ) {
        Confirmation.swalEmptyTask();
      } else {
        if (
          (this.task.partner_id && this.task.permits.length == 0) ||
          (this.task.position_ids.length == 0 &&
            this.task.permits.length == 0 &&
            !this.task.partner_id &&
            this.task.crane == 1)
        ) {
          this.sendTask();
        } else {
          this.$bvModal.show("send-task-modal" + this._uid);
        }
      }
    },
    saveAsDraft() {
      this.loading = true;
      Draft.add(this.draft_object)
        .then(() => {
          this.errors = [];
          this.closeAddModal();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCoordination(details) {
      this.$set(this.task, "coordination", details.coordination);
      this.$set(
        this.task,
        "coordination_partner_id",
        details.coordination_partner_id
      );
      this.$set(
        this.task,
        "coordination_user_id",
        details.coordination_user_id
      );
    },
  },
};
</script>
<style>
.help-anchor {
}
.help-anchor .help-text {
  display: none;
}

.help-anchor:hover .help-text {
  text-align: left;
  background: #ececec;
  display: block;
  position: absolute;
  z-index: 999;
  padding: 10px;
  border: 1px solid #383838;
}
.input-container input {
  border: none;
  box-sizing: border-box;
  outline: 0;
  padding: 0.75rem;
  position: relative;
  width: 100%;
}
</style>
